import React from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { itemCount: 0, menuOpen: false };
  }

  componentDidMount() {
    this.refreshCount();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cartVersion !== this.props.cartVersion) {
      this.refreshCount();
    }
  }

  refreshCount() {
    api.getCart()
      .then((cart) => {
        const count = cart.items.reduce((sum, i) => sum + i.quantity, 0);
        this.setState({ itemCount: count });
      })
      .catch(() => {});
  }

  render() {
    return (
      <header className="navbar">
        <Link to="/" className="brand">
          <img src="/logo.jpeg" alt="Zinex Softwares" className="brand-logo" />
        </Link>
        <nav className={this.state.menuOpen ? 'nav-links open' : 'nav-links'}>
          <Link to="/" onClick={() => this.setState({ menuOpen: false })}>Home</Link>
          <Link to="/products" onClick={() => this.setState({ menuOpen: false })}>Licenses</Link>
          <Link to="/about" onClick={() => this.setState({ menuOpen: false })}>About Us</Link>
          <Link to="/cart" className="cart-link" onClick={() => this.setState({ menuOpen: false })}>
            Cart {this.state.itemCount > 0 && <span className="cart-badge">{this.state.itemCount}</span>}
          </Link>
        </nav>
        <button
          className="nav-toggle"
          aria-label="Toggle menu"
          onClick={() => this.setState((s) => ({ menuOpen: !s.menuOpen }))}
        >
          ☰
        </button>
      </header>
    );
  }
}

export default Navbar;
